const React = require('react')

// exports.wrapRootElement = ({ element }) => {
// 	return <React.StrictMode>{element}</React.StrictMode>
// }
